import { ConfirmationService } from "primeng/api";

export function confirmMessage(confirmationService: ConfirmationService, message: string, acceptFn: any = null, rejectFn: any = null) {
    confirmationService.confirm({
        header: "Внимание!",
        message: message,
        icon: 'pi pi-info-circle',
        acceptButtonStyleClass: 'p-button-danger p-button-sm',
        rejectButtonStyleClass: 'p-button p-button-sm',
        acceptLabel: "Да",
        rejectLabel: "Нет", 
        rejectVisible: true,
        accept: () => {
            if(acceptFn && typeof acceptFn === "function") {
                acceptFn();
            }
        },
        reject: () => {
            if(rejectFn && typeof rejectFn === "function") {
                rejectFn();
            } 
        }
    });
}

export function alertMessage(confirmationService: ConfirmationService, message: string, acceptFn: any = null) {
    confirmationService.confirm({
        header: "Внимание!",
        message: message,
        icon: 'pi pi-info-circle',
        // acceptButtonStyleClass: 'p-button-danger p-button-sm',
        acceptLabel: "Ok",
        rejectVisible: false,
        accept: () => {
            if(acceptFn && typeof acceptFn === "function") {
                acceptFn();
            }
        },
    });


}